// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloseSquareFilledSvg from "@ant-design/icons-svg/es/asn/CloseSquareFilled";
import AntdIcon from '../components/AntdIcon';

var CloseSquareFilled = function CloseSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloseSquareFilledSvg
  }));
};

CloseSquareFilled.displayName = 'CloseSquareFilled';
export default React.forwardRef(CloseSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CloseSquareFilled.js
// module id = 791
// module chunks = 0